<template>
  <div class="container">
    <!-- 运输方式 -->
    <div class="transport-container">
      <slot name="transport"></slot>
    </div>
    <!-- 运输时效 -->
    <div class="time-container">
      <slot name="time"></slot>
    </div>

    <!-- 通用list -->
    <div class="list">
      <slot name="list"></slot>
    </div>

    <!-- 晚到赔偿 -->
    <div class="pay-container">
      <slot name="pay"></slot>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.container {
  padding: 24px 0 0 48px;
  color: #fff;
  .transport-container {
    h2 {
      font-weight: bold;
      color: #fff;
    }
  }
  .time-container {
    h3 {
      color: #ff5d1b;
    }
  }
  .pay-container {
    h3 {
      font-weight: bold;
      color: #fff;
    }
  }
  .list {
    h2 {
      color: #fff;
    }
    h3 {
      color: #ff5d1b;
    }
  }
}
</style>